import React from 'react';
const Toast = ({ message, type }) => {
    return (React.createElement("div", { className: `toast show ${type}` }, message));
};
export default Toast;
